console.log('js/where_hear_about_us.js -> v0.1.0');

$(function() {
	$(".hear-about-us-confirmation").hide();

	$('.hear-about-us-send').on('click', function() {
		var text = $("#channel").val();
		if(text == null)
			return false;

		if(text == "other")
			text = $("#other").val();

		var url = '/customer/confirmation/customer_selected_channel';
		var token = getUrlParameter('token');

		$.ajax({
			type: 'POST',
			url: url,
			data: '{"token" : "' + token+'", "text" : "' + text +'"}',
			contentType: 'application/json'
		}).done(response => {
			hearAboutUsSuccess();
		})

		return false;
	});

	$('#channel').change(function(){
		var selected_item = $(this).val()

		if(selected_item == "other"){
			$('#other').val("").removeClass('js-hide');
		}else{
			$('#other').val(selected_item).addClass('js-hide');
		}
	});

});

function hearAboutUsSuccess(){
	$(".hear-about-us-container").hide();
	$(".hear-about-us-confirmation").fadeIn();
	setTimeout( function(){$(".hear-about-us-confirmation").fadeOut(); }, 3000)
}
